import { Controller } from "@hotwired/stimulus"

// Popup facture/avoir du grand livre : compte les cartes cochées, met à jour le libellé
// « Affecter (n) » / « Désaffecter (n) » et bloque l'envoi sans sélection.
// En affectation (`remainingCents` présent), les montants proposés des cartes non cochées suivent
// le reste à couvrir ; saisir un montant coche sa carte, et un dépassement affiche un message et bloque l'envoi.
export default class extends Controller {
  static targets = ["checkbox", "submit", "amount", "error"]
  static values = {
    label: String,
    remainingCents: Number,
    exceedsEntry: String,
    exceedsCounterpart: String,
  }

  connect() {
    this.update()
  }

  update(event) {
    // Saisir un montant vaut sélection : sinon le recalcul écraserait la saisie.
    if (event?.target && this.amountTargets.includes(event.target)) {
      const checkbox = this.checkboxFor(event.target)
      if (checkbox) checkbox.checked = true
    }

    let count = 0
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.checked) count += 1
      checkbox.closest(".ledger-allocation-picker__card")?.classList.toggle("is-checked", checkbox.checked)
    })

    const error = this.hasRemainingCentsValue ? this.refreshAmounts() : null
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = error || ""
      this.errorTarget.hidden = !error
    }

    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = count === 0 || Boolean(error)
    this.submitTarget.value = count > 0 ? `${this.labelValue} (${count})` : this.labelValue
  }

  refreshAmounts() {
    const rows = this.amountTargets.map((input) => ({
      input,
      checked: this.checkboxFor(input)?.checked,
      availableCents: Number(input.dataset.availableCents),
    }))

    const checked = rows.filter((row) => row.checked)
    const checkedCents = checked.reduce((sum, row) => sum + (this.parseCents(row.input.value) || 0), 0)
    const leftCents = Math.max(this.remainingCentsValue - checkedCents, 0)

    rows.filter((row) => !row.checked).forEach((row) => {
      row.input.value = this.formatCents(Math.min(leftCents, row.availableCents))
    })

    if (checked.some((row) => this.parseCents(row.input.value) > row.availableCents)) return this.exceedsCounterpartValue
    if (checkedCents > this.remainingCentsValue) return this.exceedsEntryValue
    return null
  }

  checkboxFor(input) {
    return input.closest(".ledger-allocation-picker__card")?.querySelector(".ledger-allocation-picker__check")
  }

  parseCents(value) {
    const number = Number.parseFloat(String(value).replace(/[\s  ]/g, "").replace(",", "."))
    return Number.isFinite(number) ? Math.round(number * 100) : null
  }

  formatCents(cents) {
    return (cents / 100).toFixed(2).replace(".", ",")
  }
}
